/**
 * `core/loadState.js`
 * - ロード状態を管理
 * - ローディングの状況を判定し、body クラスを変更
 *
 * 使用方法:
 * - import {initLoadState} from "core/loadState.js";
 */


export function initLoadState() {
  pageLoader();
}


const pageLoader = () => {
  const body = document.body;
  body.classList.add("is-loading"); // 初期状態

  const setLoaded = () => {
    body.classList.remove("is-loading");
    body.classList.add("is-loaded"); // 読み込み完了後に付与
    console.log("🚀 Page fully loaded.");
  };

  if (document.readyState === "complete") {
    setLoaded(); // すでに読み込み済みなら即時実行
  } else {
    window.addEventListener("load", () => {
      requestAnimationFrame(setLoaded); // requestAnimationFrame でスムーズに処理
    });
  }
};